/**
 * Сегмент пути для задачи: url_ref с API или slug, иначе числовой id.
 * Чисто числовой slug не используем: в URL цифры значат pk.
 */
export function taskNavRef(task) {
  if (!task) return '';
  if (task.url_ref != null && String(task.url_ref).trim() !== '') {
    return String(task.url_ref).trim();
  }
  if (task.slug != null && String(task.slug).trim() !== '') {
    const slug = String(task.slug).trim();
    if (slug && !/^\d+$/.test(slug)) return slug;
  }
  return task.id != null ? String(task.id) : '';
}

/** Совпадает ли загруженная задача с сегментом /work/:taskSlug. */
export function taskMatchesNavRef(task, ref) {
  if (!task || ref == null || String(ref).trim() === '') return false;
  const want = String(ref).trim();
  if (taskNavRef(task) === want) return true;
  return task.id != null && String(task.id) === want;
}
